<template>
  <div class="wrapper">

    <navView></navView>
    <div class="main">

      <main class="content mt-0 p-0">

        <navbar class="mb-5"></navbar>

        <breadcrumbView></breadcrumbView>

        <div class="mb-5">
          <router-view />
        </div>


			</main>
    </div>
    
    
  </div>
</template>
  
<script>
import navView from '@/views/components/navView.vue'
import navbar from '@/views/components/navbar.vue'
import breadcrumbView from '@/views/components/breadcrumbView.vue'
export default {
  components: {
    navView,navbar,breadcrumbView
  }
};
</script>
<style scoped>
.main {
  padding: 0 1rem;
}
@media screen and (max-width: 1024px) {
  .main {
    padding: 0 1rem;
  }
}
</style>